import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleSignupService } from 'src/app/core/services/role-signup.service';
import { ConfirmedValidators } from 'src/app/_helpers/confirmed.validators';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';

@Component({
  selector: 'app-role-signup',
  templateUrl: './role-signup.component.html',
  styleUrls: ['./role-signup.component.scss']
})
export class RoleSignupComponent implements OnInit {

  public showClientOtp:boolean=false;
  public roleVerifyForm:FormGroup;
  public roleUser=JSON.parse(localStorage.getItem("roleUser"))
  public roleOtpData:FormGroup;
  successful: boolean=false;
  data: any;
  submitted: boolean;
  public email: string;
  public hide: boolean=true;
  public hide2: boolean=true;
  constructor(public fb:FormBuilder,
    public roleSignupService:RoleSignupService,
    private toastService: ToastNotificationService,
    public router:Router,
    public route:ActivatedRoute) { }

  ngOnInit(): void {
    // this.route.paramMap.subscribe((p) => {
    //   this.email = p.get("email");
    // });

    this.route.queryParams.subscribe(params => {
      this.email= params['email'];
    });
    this.getRoleUserByEmailId();
    this.roleVerifyForm=this.fb.group({

      firstName:  [ "",[Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      lastName:["",[Validators.required,Validators.pattern('^[a-zA-Z ]*$')]],
      email:["",[Validators.required,Validators.pattern("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$")]],
      username:["",[Validators.required,Validators.pattern("[0-9]{10}")]],
      acceptTerms: ["", [Validators.required]],



    });
    this.roleOtpData=this.fb.group({
     emailotp:  [ "",[Validators.required,Validators.pattern("[0-9]{6}")]],
     password:["",[Validators.required]],
     ConfirmPassword:["",[Validators.required]],
    },{
      validator: ConfirmedValidators('password', 'ConfirmPassword')
    });



  }
  get otp(){
  return this.roleOtpData.controls
  }
  get f(){
    return this.roleVerifyForm.controls
  }

  getRoleUserByEmailId(){
    this.roleSignupService.getUserBasedRoleByEmailId({},this.email).then((res=>{
      this.data=res.data;
      this.roleVerifyForm.patchValue({
        firstName:res.data.firstName,
        lastName:res.data.lastName,
        email:res.data.email,
        username:res.data.mobile,
      })

    }))
  }
  sentOtpRole(){
   // this.submitted=true;
    if(this.roleVerifyForm.invalid){
      return false;
    }
    this.roleSignupService.sendRoleUsersOtp(this.roleVerifyForm.value).then((data)=>{

    })
    this.showClientOtp=true;
    this.successful=true;
  }
  toggleShow() {
      this.hide = !this.hide;
  }
  toggleShow2(){
    this.hide2=!this.hide2
  }
  verifyRole(){
    this.submitted=true;
    if(this.roleOtpData.invalid){
      return false;
    }
    let data={
      "email":this.email,
      ...this.roleOtpData.value

    }
     this.roleSignupService.verifyRoleUsers(data).then(res=>{
     this.router.navigate(['/auth/role-selection'])
    }).catch((err) => {
      if (err.status === 406) {
        this.toastService.toastMsg({
          title: "Error",
          content: "OTP invalid or expired.",
        });
      }
    })
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }


}
